import API from "../lib/api";

export const getPermissions = async () => {
  try {
    const response = await API.get("acl/permissions");
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createPermission = async (data) => {
  try {
    const response = await API.post("acl/permissions", data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updatePermission = async (id, data) => {
  try {
    const response = await API.put(`acl/permissions/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deletePermission = async (id) => {
  try {
    const response = await API.delete(`acl/permissions/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getUserPermissions = async (userId) => {
  try {
    const response = await API.get(`acl/user-permissions/${userId}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateUserPermissions = async (data) => {
  try {
    const response = await API.put(`acl/user-permissions-update`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
